import React from 'react'
import classes from './footer.module.scss';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";

const mainMenu = [
  {
    label: 'Home',
    path: '/'
  },
  {
    label: 'About',
    path: '/about'
  },
  {
    label: 'Contact',
    path: '/contact'
  },
]

const socialMenu = [
  {
    label: 'LinkedIn',
    path: 'https://www.linkedin.com/company/mifab/'
  },
]

const Footer = () => {
    const navigate = useNavigate();
    
    return (
        <footer className={classes.footer}>
      <div className='container'>
        <img src="/images/logo.png" alt="" className={classes.footer__logo} />
        <div className={classes.footer__row}>
          <div className={classes.footer__right}>
            <div>
              <h4>QUICK LINKS</h4>
              <ul>
                {mainMenu.map((item, idx) => (
                <li key={`link__${idx}`} onClick={()=> navigate(item.path)}>{item.label}</li>
                ))}
              </ul>
            </div>
            <div>
              <h4>QUICK LINKS</h4>
              <ul>
                {socialMenu.map((item, idx) => (
                <li key={`link__${idx}`} onClick={()=> window.open(item.path, '_blank')}>{item.label}</li>
                ))}
              </ul>
            </div>
            <div>
              <h4>CONTACT</h4>
              {/* <p>Remington Quirante <br /><a href='mailto:Rquirante@mifab.com'>Rquirante@mifab.com</a><br />210-722-1638</p> */}
              <p><a href='mailto:sales@mifab.com'>sales@mifab.com</a></p>
            </div>
            <div>
              <h4>POLICY</h4>
              <ul>
                <li onClick={()=> navigate('/privacy-policy')}>Privacy Policy</li>
              </ul>
            </div>
          </div>
        </div>
        <p className={classes.footer__copyright}>© 2025 MiFab  Sixe My Interceptor All rights reserved</p>
      </div>
    </footer>
    )
}
export default Footer;